<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-title>
  &nbsp;
  <button
    mat-icon-button
    (click)="handleEditComplete(false)"
    title="Cancel"
    class="close-button"
    tabindex="-1"
    >
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (data && data.scoringModel) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Scoring Model Description</mat-label>
          <input matInput [(ngModel)]="data.scoringModel.description" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Scoring Model Status</mat-label>
          <mat-select placeholder="Select a Status" [(ngModel)]="data.scoringModel.status" [disabled]="!data.canEdit">
            @for (status of data.itemStatuses; track status) {
              <mat-option [value]="status">
                {{ status }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Calculation Equation</mat-label>
          <input matInput [(ngModel)]="data.scoringModel.calculationEquation" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    <div>
      <b>Scoring Options</b>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.useUserScore" [disabled]="!data.canEdit">Use Individual User Scoring</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.useTeamScore" [disabled]="!data.canEdit">Use Team Scoring</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.useOfficialScore" [disabled]="!data.canEdit">Use Official Scoring</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.useTeamAverageScore" [disabled]="!data.scoringModel.useUserScore || !data.canEdit">Use Team Average Scoring</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.useTypeAverageScore" [disabled]="!data.scoringModel.useTeamScore || !data.canEdit">Use Type Average Scoring</mat-checkbox>
        </div>
      </div>
    </div>
    <div class="add-margin">
      <b>Display Options</b>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.useSubmit" [disabled]="!data.canEdit">Use Submit Button for Submissions</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.hideScoresOnScoreSheet" [disabled]="!data.canEdit">Hide Option Values On Scoresheet</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.displayCommentTextBoxes" [disabled]="!data.canEdit">Display Comments as Textboxes</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.displayScoringModelByMoveNumber" [disabled]="!data.canEdit">Use Different Scoring Categories by Move Number</mat-checkbox>
        </div>
      </div>
      <div class="scoring-option">
        <div>
          <mat-checkbox [(ngModel)]="data.scoringModel.showPastSituationDescriptions" [disabled]="!data.canEdit">Show Past Situation Descriptions on Dashboard</mat-checkbox>
        </div>
      </div>
      <div class="add-margin"> &nbsp;</div>
      <div class="scoring-option">
        <div>
          <mat-form-field class="description-field full-width">
            <mat-label>Right Side Display</mat-label>
            <mat-select placeholder="Select a Right Side Display Option" [(ngModel)]="data.scoringModel.rightSideDisplay" [disabled]="!data.canEdit">
              @for (item of data.rightSideDisplays; track item) {
                <mat-option [value]="item">
                  {{ item }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (data.scoringModel.rightSideDisplay === 'HtmlBlock') {
        <div class="scoring-option">
          <mat-label class="gray">Right Side HTML Block</mat-label>
          <angular-editor [placeholder]="'Enter content here...'" [(ngModel)]="data.scoringModel.rightSideHtmlBlock" [config]="editorConfig" [disabled]="!data.canEdit"></angular-editor>
        </div>
      }
      @if (data.scoringModel.rightSideDisplay === 'EmbeddedUrl') {
        <div class="scoring-option">
          <div>
            <mat-form-field class="description-field full-width">
              <mat-label>Right Side URL</mat-label>
              <input matInput [(ngModel)]="data.scoringModel.rightSideEmbeddedUrl" [disabled]="!data.canEdit" />
            </mat-form-field>
          </div>
        </div>
      }
    </div>
    <div class="cssLayoutRowStartCenter bottom-button">
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!data.canEdit || !errorFree()" style="margin-left: 40px;">Save</button>
      </div>
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
      </div>
    </div>
  </div>
}
